

import { http } from "@/http/http.js";

//获取枚举值
export function getDictList (params) {
    return http.post("/common/getDictList", params);
}


//添加记录仪
export function cameraSave (params) {
    return http.post("/web/camera/save", params);
}
//分页查询
export function queryCameraPage (params) {
    return http.post("/web/camera/queryCameraPage", params);
}


//删除
export function cameraDelete (params) {
    return http.post("/web/camera/delete", params);
}

export function cameraDownload () {
    return http.postUpload("/web/camera/download");
}


//车辆管理
export function carListPage (params) {
    return http.post("/web/car/listPage", params);
}

export function carAdd (params) {
    return http.post("/web/car/add", params);
}

export function carDelete (params) {
    return http.post("/web/car/delete", params);
}

export function listPageUsage (params) {
    return http.post("/web/car/listPageUsage", params);
}

export function addUsage (params) {
    return http.post("/web/car/addUsage", params);
}

export function carUpdate (params) {
    // console.log("mars",params)
    return http.post("/web/car/update", params);
}

export function listPageIllegal (params) {
    return http.post("/web/car/listPageIllegal", params);
}

export function addIllegal (params) {
    return http.post("/web/car/addIllegal", params);
}
export function dealIllegal (params) {
    return http.post("/web/car/dealIllegal", params);
}
export function listPageRepair (params) {
    return http.post("/web/car/listPageRepair", params);
}
export function addRepair (params) {
    return http.post("/web/car/addRepair", params);
}
//修改保养
export function updateRepair (params) {
    return http.post("/web/car/updateRepair", params);
}
//删除保养
export function deleteRepair (params) {
    return http.post("/web/car/deleteRepair", params);
}
export function listPageInsurance (params) {
    return http.post("/web/car/listPageInsurance", params);
}


export function addInsurance (params) {
    return http.post("/web/car/addInsurance", params);
}

export function urlDirect (data) {
    return http.post("/web/azl/urlDirect", data);
}